
import {useState, useEffect} from 'react';

import './App.css';

function App() {
  const [message, setMessage] = useState('');
  useEffect(() => {
    fetch('https://damp-hill-7d33.ling48711.workers.dev/')
      .then((response) => response.json())
      .then((data) => setMessage(data.message))
      .catch((error) => console.error(error));
  }, []);
  return (
    <div className="App">
        <p>hello world</p>
        <p>{`Message from Worker: ${message}`}</p>
    </div>
  );
}

export default App;